export // Define Ant Design columns
const columns = [
  {
    title: "Integration Name",
    dataIndex: "name",
    key: "name",
    //render: (text) => <span>{text}</span>,
    sortDirections: ["ascend", "descend"], // Optional: Sets sort directions for ascending and descending
    sorter: (a, b) => a.rawName.localeCompare(b.rawName),
  },
  {
    title: "Trigger",
    dataIndex: "trigger",
    key: "trigger",
    filters: [
      {
        text: "Issue Event",
        value: "ATLASSIAN",
      },
      {
        text: "Scheduled",
        value: "SCHEDULE",
      },
      {
        text: "Webhook",
        value: "CUSTOM_WEBHOOK_TRIGGER_TYPE",
      },
    ],
    onFilter: (value, record) => record.rawTrigger.indexOf(value) === 0,
  },
  {
    title: "Last Run",
    dataIndex: "status",
    key: "status",
    sorter: (a, b) => {
      const labelA = (a.rawStatus || "").toUpperCase();
      const labelB = (b.rawStatus || "").toUpperCase();
      if (labelA < labelB) return -1;
      if (labelA > labelB) return 1;
      return 0;
    },
  },
  {
    title: "Last modified",
    dataIndex: "modified",
    key: "modified",
    sortDirections: ["ascend", "descend"],
    sorter: (a, b) => new Date(a.modified) - new Date(b.modified),
  },
  {
    title: "Enabled",
    dataIndex: "enabled",
    key: "enabled",
    filters: [
      {
        text: "Enabled",
        value: true,
      },
      {
        text: "Disabled",
        value: false,
      },
    ],
    onFilter: (value, record) => record.rawEnabled === value,
    sorter: (a, b) => a.rawEnabled - b.rawEnabled,
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
  },
];
